import { ref, computed, onMounted, resolveComponent, openBlock, createBlock, withCtx, withDirectives, createElementVNode, normalizeClass, createCommentVNode, renderSlot, normalizeStyle, createElementBlock, Fragment, toDisplayString, vShow } from 'vue';
import { createComponent } from './utils/create-component';
import { INPUT_EVENT, CLICK_EVENT, RIGHT_CLICK_EVENT } from './utils/constants';
import Transition from './transition';
import propTypes from './utils/prop-types';
import Icon from './icon';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 样式类型
   */
  type: propTypes.string().def('notification'),
  /**
   * 消息通知栏标题
   */
  title: propTypes.string().def(''),
  /**
   * 消息通知栏内容
   */
  content: propTypes.string().def(''),
  /**
   * 左侧图标名称或图片链接，等同于Icon组件的name属性
   */
  leftIcon: propTypes.string().def('base_select'),
  /**
   * 左侧图标颜色
   */
  leftIconColor: propTypes.string().def('#fff'),
  /**
   * 右侧链接或按钮文字
   */
  linkText: propTypes.string().def('去看看'),
  /**
   * 模式为链接时的右侧图标
   */
  linkIcon: propTypes.string().def('base_next_24'),
  /**
   * 右侧图标颜色
   */
  linkIconColor: propTypes.string().def('#fff'),
  /**
   * 停留时间
   */
  duration: propTypes.number().def(0),
  /**
   * 显隐动画
   */
  transition: propTypes.string().def('fade')
};
var emits = [INPUT_EVENT, CLICK_EVENT, RIGHT_CLICK_EVENT];

var _components;
var _createComponent = createComponent('snackbar'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: (_components = {}, _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Transition.name, Transition), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var isShowSnackbar = ref(true);
    var timer;
    // 类型判断
    var isDefaultType = ref(props.type === 'notification');
    var isFunctionalType = ref(props.type === 'functional');
    // class样式
    var classes = computed(function () {
      var type = props.type;
      return [className, "".concat(className, "-").concat(type), "".concat(className, "-round")];
    });
    // 左侧图标样式
    function getLeftIconStyle() {
      return {
        color: props.leftIconColor,
        fontSize: "".concat(isDefaultType.value ? 14 : 28, "px")
      };
    }
    // 右侧图标样式
    function getLinkIconStyle() {
      return {
        color: props.linkIconColor,
        fontSize: "14px"
      };
    }
    /**
     * @description: 右侧区域点击
     * @param {Event} e
     * @return {*}
     */
    function onRightBoxClick(e) {
      emit(RIGHT_CLICK_EVENT, e);
    }
    function hide() {
      isShowSnackbar.value = false;
    }
    function init() {
      clearTimeout(timer);
      if (isShowSnackbar.value && props.duration) {
        timer = setTimeout(function () {
          hide();
        }, props.duration);
      }
    }
    onMounted(function () {
      init();
    });
    return {
      isShowSnackbar: isShowSnackbar,
      slots: slots,
      isDefaultType: isDefaultType,
      isFunctionalType: isFunctionalType,
      className: className,
      classes: classes,
      getLeftIconStyle: getLeftIconStyle,
      getLinkIconStyle: getLinkIconStyle,
      onRightBoxClick: onRightBoxClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  var _component_sp_transition = resolveComponent("sp-transition");
  return openBlock(), createBlock(_component_sp_transition, {
    name: _ctx.transition
  }, {
    "default": withCtx(function () {
      return [withDirectives(createElementVNode("div", {
        "class": normalizeClass(_ctx.classes)
      }, [createCommentVNode("左侧区域 "), createElementVNode("div", {
        "class": normalizeClass(["".concat(_ctx.className, "__left"), !_ctx.slots.left && "".concat(_ctx.className, "__left-").concat(_ctx.type)])
      }, [_ctx.slots.left ? renderSlot(_ctx.$slots, "left", {
        key: 0
      }) : (openBlock(), createBlock(_component_sp_icon, {
        key: 1,
        name: _ctx.leftIcon,
        "class": normalizeClass("".concat(_ctx.className, "__left-icon-").concat(_ctx.type)),
        style: normalizeStyle(_ctx.getLeftIconStyle())
      }, null, 8 /* PROPS */, ["name", "class", "style"]))], 2 /* CLASS */), createCommentVNode(" 内容 "), createElementVNode("div", {
        "class": normalizeClass(["".concat(_ctx.className, "__content")])
      }, [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__content-box"))
      }, [_ctx.slots["default"] ? renderSlot(_ctx.$slots, "default", {
        key: 0
      }) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [_ctx.isFunctionalType && _ctx.title ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass(["".concat(_ctx.className, "__content-title")])
      }, toDisplayString(_ctx.title), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), createElementVNode("div", {
        "class": normalizeClass(["".concat(_ctx.className, "__content-").concat(_ctx.type)])
      }, toDisplayString(_ctx.content), 3 /* TEXT, CLASS */)], 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */), createCommentVNode("右侧区域 "), createElementVNode("div", {
        "class": normalizeClass(["".concat(_ctx.className, "__right"), "".concat(_ctx.className, "__right-round")])
      }, [_ctx.slots.right ? renderSlot(_ctx.$slots, "right", {
        key: 0
      }) : (openBlock(), createElementBlock("div", {
        key: 1,
        "class": normalizeClass("".concat(_ctx.className, "__right-mode")),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.onRightBoxClick && _ctx.onRightBoxClick.apply(_ctx, arguments);
        })
      }, [_ctx.isDefaultType ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass(["".concat(_ctx.className, "__right-").concat(_ctx.type)])
      }, toDisplayString(_ctx.linkText), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), _ctx.isDefaultType ? (openBlock(), createBlock(_component_sp_icon, {
        key: 1,
        name: _ctx.linkIcon,
        "class": normalizeClass("".concat(_ctx.className, "__right-").concat(_ctx.type)),
        style: normalizeStyle(_ctx.getLinkIconStyle())
      }, null, 8 /* PROPS */, ["name", "class", "style"])) : createCommentVNode("v-if", true), _ctx.isFunctionalType ? (openBlock(), createElementBlock("div", {
        key: 2,
        "class": normalizeClass("".concat(_ctx.className, "__right-").concat(_ctx.type))
      }, toDisplayString(_ctx.linkText), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */))], 2 /* CLASS */)], 2 /* CLASS */), [[vShow, _ctx.isShowSnackbar]])];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]);
}

script.render = render;
script.__file = "components/src/component/snackbar/snackbar.vue";

var _Snackbar = script;

export { _Snackbar as default };
